export const CATEGORIES_COMPARISON_ITEMS = {
  whatTheyNeedFromYou: {
    title: 'What They Need From You',
    icon: 'far fa-hand-peace',
  },
  whatYouNeedFromThem: {
    title: 'What You Need From Them',
    icon: 'far fa-seedling',
  },
  startTalking: {
    title: 'Start Talking',
    icon: 'far fa-comment',
  },
  startActing: {
    title: 'Start Acting',
    icon: 'far fa-clipboard-list',
  },
};
